import { c as create_ssr_component, e as escape, b as add_attribute, v as validate_component, d as each, a as subscribe } from "../../chunks/ssr.js";
import { A as Animate, D as DownloadButton, I as Icon, u as userCount, r as release, L as Loading, N as Navbar, F as Footer } from "../../chunks/Loading.js";
const demo$1 = "/_app/immutable/assets/demo.b5f5f8a8.mp4";
const Detail = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { icon = "" } = $$props;
  let { title = "" } = $$props;
  let { description = "" } = $$props;
  if ($$props.icon === void 0 && $$bindings.icon && icon !== void 0)
    $$bindings.icon(icon);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.description === void 0 && $$bindings.description && description !== void 0)
    $$bindings.description(description);
  return `<div class="gap-4 flex flex-col w-full md:max-w-sm"><div class="p-4 rounded-full flex items-center justify-center bg-white text-teal-500 self-start"><span class="material-symbols-outlined">${escape(icon)}</span></div> <div class="flex flex-col gap-2"><div class="text-2xl font-display font-bold">${escape(title)}</div> <div class="opacity-70 text-xl leading-relaxed">${escape(description)}</div></div></div>`;
});
const HeroBanner = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  const detail = [
    {
      icon: "monitor",
      title: "Multi-Monitor Support",
      description: "Supports direct monitor adjustments for 100K+ monitors and displays."
    },
    {
      icon: "schedule",
      title: "Custom Schedules",
      description: "Set your brightness to adjust automatically, aligning with your daily workflow. Enjoy perfect lighting, from dawn till dusk."
    },
    {
      icon: "donut_small",
      title: "Shade Mode",
      description: "For old or incompatible monitors, simulate brightness adjustments with a dark, translucent overlay."
    }
  ];
  return `${$$result.head += `<!-- HEAD_svelte-1rrg2a8_START --><link rel="preload" as="image"${add_attribute("href", demo$1, 0)}><!-- HEAD_svelte-1rrg2a8_END -->`, ""}  <div class="section-container bg-white text-black relative z-0 pt-12"><div class="section !px-0 pb-12 md:!py-24 bg-teal-900/5 rounded-3xl relative z-20 bg-repeat bg-contain"><div class="section !px-0 relative z-10"><div class="text-center lg:text-left grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"><div class="space-y-12 z-10 p-12"><div class="space-y-8 text-shadow-2xl shadow-amber-100/10">${validate_component(Animate, "Animate").$$render($$result, {}, {}, {
    default: () => {
      return `<div class="max-w-sm mx-auto lg:mx-0 lg:text-left text-center text-5xl lg:text-7xl text-transparent font-display font-black flex md:block justify-center" data-svelte-h="svelte-lzpg3q"><span class="bg-clip-text bg-black capitalize leading-snug">Meet the ultimate brightness tool</span></div>`;
    }
  })} ${validate_component(Animate, "Animate").$$render($$result, { delay: "0.1s" }, {}, {
    default: () => {
      return `<div class="text-2xl md:text-4xl font-display opacity-80" data-svelte-h="svelte-141qrjm">Easily adjust brightness for all your displays right from your system
								tray.</div>`;
    }
  })}</div> ${validate_component(Animate, "Animate").$$render(
    $$result,
    {
      delay: "0.2s",
      className: "flex gap-4 flex-wrap justify-center lg:justify-start"
    },
    {},
    {
      default: () => {
        return `${validate_component(DownloadButton, "DownloadButton").$$render(
          $$result,
          {
            primary: true,
            size: 2,
            showFileSize: true,
            enableStoreDownload: true
          },
          {},
          {}
        )}`;
      }
    }
  )}</div> <div class="shrink-0 -order-1 lg:order-1 lg:pr-12 md:p-0 flex items-center justify-center w-full h-full relative"><div class="w-full max-w-2xl">${validate_component(Animate, "Animate").$$render($$result, {}, {}, {
    default: () => {
      return `<video class="w-full h-full md:rounded-3xl rounded-t-3xl lg:shadow-2xl" autoplay loop muted playsinline data-svelte-h="svelte-ie8wmi"><source${add_attribute("src", demo$1, 0)} type="video/mp4"></video>`;
    }
  })}</div></div></div></div> <div class="section flex flex-col justify-center md:flex-row flex-wrap gap-12 mt-24">${each(detail, ({ icon, title, description }, i) => {
    return `${validate_component(Detail, "Detail").$$render($$result, { icon, title, description }, {}, {})}`;
  })}</div></div></div>`;
});
const Features = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  const features = [
    {
      icon: "light_mode",
      title: "Precise Brightness Control",
      description: "Effortlessly adjust display brightness individually or in sync with other displays."
    },
    {
      icon: "schedule",
      title: "Personalized Brightness Schedules",
      description: "Easily modify brightness levels based on the time of day."
    },
    {
      icon: "sync_saved_locally",
      title: "Universal Monitor Compatibility",
      description: "Unlike other brightness tools, Glimmr works with all display types, regardless of connection type."
    },
    {
      icon: "model_training",
      title: "Brightness Profiles",
      description: "Easily switch between brightness levels for different lighting scenarios with predefined modes or customize your own."
    },
    {
      icon: "sentiment_very_satisfied",
      title: "Reduced Eye Strain",
      description: "Prolonged exposure to bright screens can cause eye strain. If it's too cumbersome to adjust your monitor's brightness manually, Glimmr can help."
    },
    {
      icon: "rocket_launch",
      title: "Auto Startup",
      description: "Glimmr starts up with Windows by default and automatically applies your predefined brightness adjustments so you don't have to."
    }
  ];
  return `<section class="bg-teal-900/10 text-black relative overflow-hidden"><div class="container mx-auto space-y-4 py-36 px-6 md:px-12"><div class="grid grid-cols-1 gap-12 items-center z-10 relative"><h1 class="text-6xl font-display text-black font-bold text-center leading-tight md:leading-tight" data-svelte-h="svelte-lvvwuo">Designed for
				simplicity</h1> <section class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 p-2 md:p-0">${each(features, (feature, i) => {
    return `<div class="w-full h-full flex items-stretch justify-stretch">${validate_component(Animate, "Animate").$$render($$result, { className: "flex-grow" }, {}, {
      default: () => {
        return `<section class="p-4 md:p-12 gap-8 h-full text-left flex flex-col"><div class="flex flex-col items-center justify-center size-16 p-12 bg-white text-teal-500 rounded-3xl"><span class="material-symbols-outlined !text-5xl">${escape(feature.icon)} </span></div> <div class="flex flex-col gap-4"><h1 class="text-4xl font-display text-black leading-tight font-bold">${escape(feature.title)}</h1> <p class="text-xl opacity-80 leading-relaxed">${escape(feature.description)}</p> </div></section> `;
      }
    })} </div>`;
  })}</section> <div class="mx-auto">${validate_component(DownloadButton, "DownloadButton").$$render($$result, { size: 4 }, {}, {})}</div></div></div></section>`;
});
const QA = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { question = "" } = $$props;
  let { answer = "" } = $$props;
  if ($$props.question === void 0 && $$bindings.question && question !== void 0)
    $$bindings.question(question);
  if ($$props.answer === void 0 && $$bindings.answer && answer !== void 0)
    $$bindings.answer(answer);
  return `<section class="${"rounded-3xl flex flex-col items-center justify-center p-6 cursor-pointer transition " + escape(
    "bg-white text-black hover:bg-teal-900/10",
    true
  )}"><div class="flex items-center justify-between text-left w-full"><h1 class="font-medium transition max-w-2xl font-display text-xl">${escape(question)}</h1> <span class="material-symbols-outlined">${escape("expand_more")}</span></div> <div><p class="text-left pt-4 pb-2 text-xl leading-relaxed opacity-90">${escape(answer)}</p></div></section>`;
});
const FAQ = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  const data = [
    {
      question: "How does it work?",
      answer: "Glimmr simplifies brightness adjustment by directly interfacing with your monitors through DDC/CI. This provides the same outcome as using the built-in buttons on the monitor's back or sides, but with enhanced convenience and ease-of-use."
    },
    {
      question: "Can I adjust the brightness of individual monitors in a multi-monitor setup?",
      answer: "Certainly! With Glimmr, you have the flexibility to adjust the brightness of individual monitors in a multi-monitor setup. The tool recognizes and allows you to control each connected monitor separately. This means you can fine-tune the brightness settings of each monitor independently, ensuring optimal visual experience and comfort across your entire multi-monitor configuration. Glimmr provides you with the granular control needed to tailor the brightness levels of each monitor to your specific preferences and requirements."
    },
    {
      question: "Can I set a global brightness level?",
      answer: "Yes, you have the ability to set a global brightness level for all your monitors simultaneously with a single slider. This means you can adjust the brightness of all connected monitors at once, ensuring a uniform and consistent brightness experience across your entire display setup. It's a convenient feature that saves you time and effort, as you don't have to adjust each monitor individually."
    },
    {
      question: "Is the app compatible with all versions of Windows?",
      answer: "Glimmr should run on all versions of Windows 7 and up, including Windows 8, 10, and 11."
    },
    {
      question: "Does the app work with monitors from different manufacturers?",
      answer: "Absolutely! Glimmr utilizes DDC/CI to directly adjust brightness, ensuring compatibility with a wide range of monitors. In case you encounter flickering or consistent brightness levels, consider trying a different connection type (preferably direct instead of using adapters or USB-C hubs). Alternatively, you can utilize Shade Mode, which works seamlessly on all monitors regardless of the connection type."
    },
    {
      question: "What is Shade Mode?",
      answer: "With a premium license, you can easily activate Shade Mode on any monitor. This feature enables you to adjust the brightness of your monitors by creating an Always-On-Top (AOT) semi-transparent window on the desired monitor. Please note that certain native Windows elements, such as the taskbar, may appear above this window when focused. Shade Mode is particularly useful if you frequently rely on adapters or USB-C hubs for monitor connections, encounter issues when adjusting brightness natively, or prefer setting your monitors to lower brightness levels than what they typically offer."
    },
    {
      question: "Can I schedule automatic brightness adjustments based on specific times of day?",
      answer: "Absolutely! The scheduling feature allows you to create a custom brightness schedule tailored to your preferences. Simply specify the target monitors, desired times, and corresponding brightness levels, and Glimmr will automatically adjust the brightness of your monitors according to the schedule you've set. This enables you to have an optimized viewing experience at different times, without the need for manual adjustments."
    },
    {
      question: "Is the app compatible with both desktop and laptop computers?",
      answer: "Yes, you can use Glimmr to adjust both internal and external monitors. It can also be used from a laptop or desktop, whichever you prefer."
    }
  ];
  return `<div><section class="w-full bg-white border-t border-gray-100"><div class="section flex flex-col items-center py-24 gap-12 text-center"><div class="space-y-6" data-svelte-h="svelte-1mmyvgg"><h1 class="text-5xl md:text-6xl font-display font-bold">Got questions?</h1> <p class="opacity-70 text-2xl">We&#39;ve got answers. Check out our most frequently asked questions below.</p></div> <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">${each(data, (content, i) => {
    return `${validate_component(Animate, "Animate").$$render($$result, {}, {}, {
      default: () => {
        return `${validate_component(QA, "QA").$$render(
          $$result,
          {
            question: content.question,
            answer: content.answer
          },
          {},
          {}
        )} `;
      }
    })}`;
  })}</div></div></section></div>`;
});
const SplitScreen = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  return `<div class="w-full grid grid-cols-1 md:grid-cols-4 gap-24 items-center">${validate_component(Animate, "Animate").$$render($$result, { className: "col-span-2" }, {}, {
    default: () => {
      return `${slots.left ? slots.left({}) : ``}`;
    }
  })} ${validate_component(Animate, "Animate").$$render($$result, { className: "col-span-2" }, {}, {
    default: () => {
      return `${slots.right ? slots.right({}) : ``}`;
    }
  })}</div>`;
});
const demo = "/_app/immutable/assets/glimmr-product-diagram.fbd4a730.png";
const Intro = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  return `<section class="bg-white relative text-black overflow-hidden"><div class="container mx-auto space-y-12 py-36 px-6 md:px-12"><div class="mx-auto z-10 relative space-y-24">${validate_component(SplitScreen, "SplitScreen").$$render($$result, {}, {}, {
    right: () => {
      return `<div slot="right"><div class="space-y-8 flex flex-col items-center max-w-lg mx-auto text-center">${validate_component(Icon, "Icon").$$render(
        $$result,
        {
          icon: "mdi:cursor-default-click",
          class: "text-6xl text-teal-500"
        },
        {},
        {}
      )} ${validate_component(Animate, "Animate").$$render($$result, {}, {}, {
        default: () => {
          return `<div class="text-teal-500 text-4xl md:text-5xl lg:text-6xl font-display leading-tight font-bold" data-svelte-h="svelte-1wkdxf8">Accessible &amp; Convenient</div>`;
        }
      })} ${validate_component(Animate, "Animate").$$render($$result, {}, {}, {
        default: () => {
          return `<div class="opacity-70 font-display text-xl lg:text-2xl !leading-relaxed" data-svelte-h="svelte-pgm65e">No more fiddling with monitor settings or dealing with the dreaded Windows brightness slider. All your displays will be automatically detected and available for adjustment.</div>`;
        }
      })}</div></div>`;
    },
    left: () => {
      return `<div slot="left" data-svelte-h="svelte-1j1x5zy"><img${add_attribute("src", demo, 0)} alt="demo"></div>`;
    }
  })}                      </div></div></section>`;
});
const happyCustomer = "/_app/immutable/assets/happy-customer.724fdcdc.png";
const mia = "/_app/immutable/assets/mia.c5a72ff1.png";
const jordan = "/_app/immutable/assets/jordan.a943380c.png";
const riley = "/_app/immutable/assets/riley.52b52fc4.png";
const alex = "/_app/immutable/assets/alex.b00f04cf.png";
const Testimonial = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { message = "" } = $$props;
  let { name = "" } = $$props;
  let { title = "" } = $$props;
  let { avatar = "" } = $$props;
  if ($$props.message === void 0 && $$bindings.message && message !== void 0)
    $$bindings.message(message);
  if ($$props.name === void 0 && $$bindings.name && name !== void 0)
    $$bindings.name(name);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.avatar === void 0 && $$bindings.avatar && avatar !== void 0)
    $$bindings.avatar(avatar);
  return `<div class="bg-teal-900/10 rounded-3xl p-8 flex flex-col gap-8 h-full"><div class="flex-grow"><span class="material-symbols-outlined transform rotate-180 text-left self-start opacity-70" style="font-size: 3rem !important;" data-svelte-h="svelte-mogzq3">format_quote</span> <div class="text-lg leading-relaxed">${escape(message)}</div></div> <div class="flex items-center space-x-2"><div class="rounded-full overflow-hidden"><img${add_attribute("src", avatar, 0)} width="48" height="48"></div> <div><div class="font-medium opacity-90">${escape(name)}</div> <div class="opacity-70">${escape(title)}</div></div></div></div>`;
});
const Testimonials = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  return `<div class="w-full bg-white"><div class="section py-36">${validate_component(SplitScreen, "SplitScreen").$$render($$result, {}, {}, {
    right: () => {
      return `<div slot="right" class="space-y-4 md:space-y-8"><div class="text-6xl font-bold font-display text-black" data-svelte-h="svelte-1lp32lj">See what our customers have to say</div> <div class="grid grid-cols-1 xl:grid-cols-2 grid-rows-2 gap-10 gap-y-16 pt-12">${validate_component(Testimonial, "Testimonial").$$render(
        $$result,
        {
          name: "Mia T.",
          title: "Digital Marketing Manager",
          message: "Before Glimmr, adjusting my monitor's brightness was a daily hassle, especially when dealing with the tiny buttons on the back of my screen. Now, I can easily manage everything from my desktop. It's not just convenient; it's a relief.",
          avatar: mia
        },
        {},
        {}
      )} ${validate_component(Testimonial, "Testimonial").$$render(
        $$result,
        {
          name: "Jordan M.",
          title: "Aspiring Writer",
          message: "The custom schedules feature in Glimmr has been a game-changer for me. I love how my screen automatically dims as the sun sets, making those long writing sessions less of a strain on my eyes. It's such a smart, user-friendly tool.",
          avatar: jordan
        },
        {},
        {}
      )} ${validate_component(Testimonial, "Testimonial").$$render(
        $$result,
        {
          name: "Riley S.",
          title: "Graphic Designer",
          message: "I'm all about aesthetics, and Glimmr is not only a lifesaver for managing my dual monitors but it's also beautifully designed. It fits perfectly into my workflow and my desktop setup. Finally, an app that gets it right.",
          avatar: riley
        },
        {},
        {}
      )} ${validate_component(Testimonial, "Testimonial").$$render(
        $$result,
        {
          name: "Alex D.",
          title: "IT Professional",
          message: "Dealing with multiple monitors used to mean constantly fiddling with settings to get a uniform look. With Glimmr, it's a one-time setup, and everything is synchronized perfectly. It's such a simple solution to what was an ongoing frustration.",
          avatar: alex
        },
        {},
        {}
      )}</div></div>`;
    },
    left: () => {
      return `<div slot="left" data-svelte-h="svelte-1dmgl6d"><img class="object-contain"${add_attribute("src", happyCustomer, 0)}></div>`;
    }
  })}</div></div>`;
});
const TrustedBy = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $userCount, $$unsubscribe_userCount;
  $$unsubscribe_userCount = subscribe(userCount, (value) => $userCount = value);
  $$unsubscribe_userCount();
  return `<div class="w-full"><div class="section flex flex-col md:flex-row gap-12 items-center justify-between py-24"><h1 class="text-4xl text-center 2xl:text-left font-display font-bold">Join our growing family of ${escape($userCount.toLocaleString())} satisfied users!</h1> ${validate_component(DownloadButton, "DownloadButton").$$render(
    $$result,
    {
      primary: false,
      size: 2,
      showFileSize: false
    },
    {},
    {}
  )}</div></div>`;
});
const _page_svelte_svelte_type_style_lang = "";
const css = {
  code: "@keyframes svelte-15sq10t-fade-in{0%{opacity:0}100%{opacity:100%}}.fade-in.svelte-15sq10t{opacity:0;animation:svelte-15sq10t-fade-in 0.5s ease-in-out forwards}",
  map: null
};
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { data } = $$props;
  if ($$props.data === void 0 && $$bindings.data && data !== void 0)
    $$bindings.data(data);
  $$result.css.add(css);
  {
    {
      release.set(data.metadata);
      userCount.set(data.userCount);
    }
  }
  return `${validate_component(Loading, "Loading").$$render($$result, {}, {}, {})} <div class="fade-in bg-white svelte-15sq10t">${validate_component(Navbar, "Navbar").$$render($$result, {}, {}, {})} ${validate_component(HeroBanner, "HeroBanner").$$render($$result, {}, {}, {})} ${validate_component(TrustedBy, "TrustedBy").$$render($$result, {}, {}, {})} ${validate_component(Intro, "Intro").$$render($$result, {}, {}, {})} ${validate_component(Features, "Features").$$render($$result, {}, {}, {})} ${validate_component(Testimonials, "Testimonials").$$render($$result, {}, {}, {})} ${validate_component(FAQ, "FAQ").$$render($$result, {}, {}, {})} ${validate_component(Footer, "DownloadBanner").$$render($$result, {}, {}, {})} </div>`;
});
export {
  Page as default
};
